import type { ListElementValue, ListItem } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { chainName, FieldArray, FormField, FieldSelect } from 'components/formKit'
import { isArrayMeta } from 'components/uiKit/ArrayControl'
import { isMixed } from 'components/uiKit/KitUtils'
import { t } from 'services/Translation'

import ListFormValueItem from './ListFormValueItem'
import type { ListValueFormType } from './listTypes'

const MODE = genElementValueField({
  as: FieldSelect<ListElementValue['mode']>,
  name: 'mode',
  label: t('elements.list.mode.label'),
  props: {
    fluid: true,
    options: [
      { value: 'number', label: t('input.option.number') },
      { value: 'point', label: t('input.option.point') },
      { value: 'images', label: t('input.option.images') },
    ],
  },
})

const ITEMS = genElementValueField({
  as: FieldArray<ListItem>,
  name: 'items',
  effect: ({ name, value, meta }) => {
    if (isArrayMeta(meta) && !isMixed(value) && value && meta.command === 'add') {
      const prevElement = value[value.length - 2]
      const newValue = value.map((item, index) =>
        index === value.length - 1 ? { ...item, number: (prevElement?.number || 0) + 1 } : item,
      )
      return { name, meta, value: newValue }
    }
    return { name, value, meta }
  },
  props: {
    RenderItem: ListFormValueItem,
    defaultItem: { number: 1, icon: null, label: textToRtValue('') },
    max: 99,
  },
})

const ListElementForm: ListValueFormType = ({ name }) => (
  <Padding bottom gap sides top>
    <FormField config={chainName(name, MODE)} />
    <FormField config={chainName(name, ITEMS)} />
  </Padding>
)

export default ListElementForm
